"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _shared = require("@clayui/shared");

var _react = _interopRequireWildcard(require("react"));

var _warning = _interopRequireDefault(require("warning"));

var _Tooltip = _interopRequireDefault(require("./Tooltip"));

var _excluded = ["type"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ALIGNMENTS = ['top', 'top-right', 'right', 'bottom-right', 'bottom', 'bottom-left', 'left', 'top-left'];
var ALIGNMENTS_MAP = {
  bottom: ['tc', 'bc'],
  'bottom-left': ['tl', 'bl'],
  'bottom-right': ['tr', 'br'],
  left: ['cr', 'cl'],
  right: ['cl', 'cr'],
  top: ['bc', 'tc'],
  'top-left': ['bl', 'tl'],
  'top-right': ['br', 'tr']
};
var ALIGNMENTS_INVERSE_MAP = {
  bctc: 'top',
  bltl: 'top-left',
  brtr: 'top-right',
  clcr: 'right',
  crcl: 'left',
  tcbc: 'bottom',
  tlbl: 'bottom-left',
  trbr: 'bottom-right'
};

var ALIGNMENTS_FORCE_MAP = _objectSpread(_objectSpread({}, ALIGNMENTS_INVERSE_MAP), {}, {
  bctc: 'top-left',
  tcbc: 'bottom-left'
});

var initialState = {
  align: 'top',
  message: '',
  setAsHTML: false,
  show: false
};
var TRIGGER_HIDE_EVENTS = ['dragstart', 'mouseout', 'mouseup', 'pointerup', 'touchend'];
var TRIGGER_SHOW_EVENTS = ['mouseover', 'mouseup', 'pointerdown', 'touchstart'];

var reducer = function reducer(state, _ref) {
  var type = _ref.type,
      payload = _objectWithoutProperties(_ref, _excluded);

  switch (type) {
    case 'align':
      return _objectSpread(_objectSpread({}, state), payload);

    case 'show':
      return _objectSpread(_objectSpread(_objectSpread({}, state), payload), {}, {
        show: true
      });

    case 'hide':
      return _objectSpread(_objectSpread({}, state), {}, {
        align: initialState.align,
        show: false
      });

    default:
      throw new TypeError();
  }
};

function matches(element, selectorString) {
  if (element.matches) {
    return element.matches(selectorString);
  } else if (element.msMatchesSelector) {
    return element.msMatchesSelector(selectorString);
  } else if (element.webkitMatchesSelector) {
    return element.webkitMatchesSelector(selectorString);
  } else {
    return false;
  }
}

function closestAncestor(node, s) {
  var element = node;
  var ancestor = node;

  if (!document.documentElement.contains(element)) {
    return null;
  }

  do {
    if (matches(ancestor, s)) {
      return ancestor;
    }

    ancestor = ancestor.parentElement;
  } while (ancestor !== null);

  return null;
}

var TooltipProvider = function TooltipProvider(_ref2) {
  var _ref2$autoAlign = _ref2.autoAlign,
      autoAlign = _ref2$autoAlign === void 0 ? true : _ref2$autoAlign,
      children = _ref2.children,
      _ref2$containerProps = _ref2.containerProps,
      containerProps = _ref2$containerProps === void 0 ? {} : _ref2$containerProps,
      _ref2$contentRenderer = _ref2.contentRenderer,
      contentRenderer = _ref2$contentRenderer === void 0 ? function (props) {
    return props.title;
  } : _ref2$contentRenderer,
      _ref2$delay = _ref2.delay,
      delay = _ref2$delay === void 0 ? 600 : _ref2$delay,
      scope = _ref2.scope;

  var _React$useReducer = _react.default.useReducer(reducer, initialState),
      _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
      _React$useReducer2$ = _React$useReducer2[0],
      align = _React$useReducer2$.align,
      _React$useReducer2$$m = _React$useReducer2$.message,
      message = _React$useReducer2$$m === void 0 ? '' : _React$useReducer2$$m,
      setAsHTML = _React$useReducer2$.setAsHTML,
      show = _React$useReducer2$.show,
      dispatch = _React$useReducer2[1]; // Using `any` type since TS incorrectly infers setTimeout to be from NodeJS


  var timeoutIdRef = _react.default.useRef();

  var targetRef = _react.default.useRef(null);

  var titleNodeRef = _react.default.useRef(null);

  var tooltipRef = _react.default.useRef(null);

  var saveTitle = (0, _react.useCallback)(function (element) {
    titleNodeRef.current = element;
    var title = element.getAttribute('title');

    if (title) {
      element.setAttribute('data-restore-title', title);
      element.removeAttribute('title');
    } else if (element.tagName === 'svg') {
      var titleTag = element.querySelector('title');

      if (titleTag) {
        element.setAttribute('data-restore-title', titleTag.innerHTML);
        titleTag.remove();
      }
    }
  }, []);
  var restoreTitle = (0, _react.useCallback)(function () {
    var element = titleNodeRef.current;

    if (element) {
      var title = element.getAttribute('data-restore-title');

      if (title) {
        if (element.tagName === 'svg') {
          var titleTag = document.createElement('title');
          titleTag.innerHTML = title;
          element.appendChild(titleTag);
        } else {
          element.setAttribute('title', title);
        }

        element.removeAttribute('data-restore-title');
      }

      titleNodeRef.current = null;
    }
  }, []);
  var handleHide = (0, _react.useCallback)(function () {
    dispatch({
      type: 'hide'
    });
    clearTimeout(timeoutIdRef.current);
    restoreTitle();

    if (targetRef.current) {
      targetRef.current.removeEventListener('click', handleHide);
      targetRef.current = null;
    }
  }, []);
  var handleShow = (0, _react.useCallback)(function (_ref3) {
    var target = _ref3.target;
    targetRef.current = target;
    var hasTitle = target && (target.hasAttribute('title') || target.hasAttribute('data-title'));
    var titleNode = hasTitle ? target : closestAncestor(target, '[title], [data-title]');

    if (titleNode) {
      target.addEventListener('click', handleHide);
      var title = titleNode.getAttribute('title') || titleNode.getAttribute('data-title') || '';
      saveTitle(titleNode);
      var customDelay = titleNode.getAttribute('data-tooltip-delay');
      var newAlign = titleNode.getAttribute('data-tooltip-align');

      var _setAsHTML = !!titleNode.getAttribute('data-title-set-as-html');

      timeoutIdRef.current = setTimeout(function () {
        dispatch({
          align: newAlign || align,
          message: title,
          setAsHTML: _setAsHTML,
          type: 'show'
        });
      }, customDelay ? Number(customDelay) : delay);
    }
  }, []);

  _react.default.useEffect(function () {
    var handleEsc = function handleEsc(event) {
      if (show && event.key === _shared.Keys.Esc) {
        event.stopImmediatePropagation();
        handleHide();
      }
    };

    document.addEventListener('keyup', handleEsc, true);
    return function () {
      return document.removeEventListener('keyup', handleEsc, true);
    };
  }, [show]);

  _react.default.useEffect(function () {
    if (scope) {
      var disposeShowEvents = TRIGGER_SHOW_EVENTS.map(function (eventName) {
        return (0, _shared.delegate)(document.body, eventName, scope, handleShow);
      });
      var disposeHideEvents = TRIGGER_HIDE_EVENTS.map(function (eventName) {
        return (0, _shared.delegate)(document.body, eventName, scope, handleHide);
      });
      return function () {
        disposeShowEvents.forEach(function (_ref4) {
          var dispose = _ref4.dispose;
          return dispose();
        });
        disposeHideEvents.forEach(function (_ref5) {
          var dispose = _ref5.dispose;
          return dispose();
        });
      };
    }
  }, []);

  _react.default.useEffect(function () {
    if (titleNodeRef.current && tooltipRef.current) {
      var points = ALIGNMENTS_MAP[align || 'top'];
      var alignment = (0, _shared.doAlign)({
        overflow: {
          adjustX: autoAlign,
          adjustY: autoAlign
        },
        points: points,
        sourceElement: tooltipRef.current,
        targetElement: titleNodeRef.current
      });
      var alignmentString = alignment.points.join('');
      var pointsString = points.join('');

      if (alignment.overflow.adjustX) {
        dispatch({
          align: ALIGNMENTS_FORCE_MAP[alignmentString],
          type: 'align'
        });
      } else if (pointsString !== alignmentString) {
        dispatch({
          align: ALIGNMENTS_INVERSE_MAP[alignmentString],
          type: 'align'
        });
      }
    }
  }, [align, show]);

  "production" !== "production" ? (0, _warning.default)(typeof children === 'undefined' && typeof scope !== 'undefined' || typeof scope === 'undefined' && typeof children !== 'undefined', '<TooltipProvider />: You must use at least one of the following props: `children` or `scope`.') : void 0;
  "production" !== "production" ? (0, _warning.default)(typeof children !== 'undefined' || typeof scope !== 'undefined', '<TooltipProvider />: If you want to use `scope`, use <TooltipProvider /> as a singleton and do not pass `children`.') : void 0;
  "production" !== "production" ? (0, _warning.default)((children === null || children === void 0 ? void 0 : children.type) !== _react.default.Fragment, '<TooltipProvider />: React Fragment is not allowed as a child to TooltipProvider. Child must be a single HTML element that accepts `onMouseOver` and `onMouseOut`.') : void 0;
  var titleContent = contentRenderer({
    targetNode: targetRef.current,
    title: message
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, show && /*#__PURE__*/_react.default.createElement(_shared.ClayPortal, containerProps, /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    alignPosition: align,
    ref: tooltipRef,
    show: true
  }, setAsHTML && typeof titleContent === 'string' ? /*#__PURE__*/_react.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: titleContent
    }
  }) : titleContent)), scope ? children : children && /*#__PURE__*/_react.default.cloneElement(children, _objectSpread(_objectSpread({}, children.props), {}, {
    onMouseOut: handleHide,
    onMouseOver: handleShow
  })));
};

var _default = TooltipProvider;
exports.default = _default;